import {useTranslation} from "react-i18next";
import {StatisticsBundleWrapper} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {LoadsByInsight, LoadsByInsightProps} from "../LoadsByInsight/LoadsByInsight";

export type LoadsByCompanyInsightProps = Omit<LoadsByInsightProps, 'data' | 'title'> & {
  data?: StatisticsBundleWrapper
}

export const LoadsByCompanyInsight = (props: LoadsByCompanyInsightProps) => {
  const {data, ...rest} = props

  const {t} = useTranslation()

  const title = useMemo(() => {
    return t("common.insight.loadsbycompany", "Loads By Company")
  }, [t])

  return (
    <LoadsByInsight
      {...rest}
      title={title}
      data={data?.truckCompanyStats}/>
  )
}
